/**
 * Immutable ExpenseCategory codes (from admin/app/startup/expense_categories.py).
 * Use these — NOT the display `name` — for code-side filtering on the
 * frontend, so operator renames via Settings don't silently change behaviour.
 */
export const DRAWER_FLOW_CODES = [
  "cash_drawer",
  "cash_drawer_opening",
  "cash_variance",
] as const;

/**
 * Codes operators should NOT see in category-picker dropdowns on
 * operator-facing pages (Expenses modal, Procurement extras add-line).
 * These are system-managed: drawer rows live on the cash drawer page,
 * Stock loss is auto-cascaded from stocktake finalize.
 */
export const OPERATOR_HIDDEN_FOR_EXPENSES = [
  ...DRAWER_FLOW_CODES,
  "stock_loss",
] as const;

/**
 * Codes hidden ONLY on the cash drawer page's cash-expense modal —
 * drawer cats SHOULD be selectable there (it's their native context),
 * but Stock loss never makes sense as a manual entry anywhere.
 */
export const OPERATOR_HIDDEN_FOR_CASH_DRAWER = ["stock_loss"] as const;
